import GHPath from "./GHPath";

export default class DataTree {
  constructor () {
    this.branches = [];
    this.paths = [];
  }

  getStringList (paths) {
    return paths.map((path) => {
      return path.toString();
    });
  }

  addEmpty (path) {
    let pathStrings = this.getStringList(this.paths);
    let index = pathStrings.indexOf(path.toString());
    if (index === -1) {
      this.paths.push(path.clone());
      this.branches.push([]);
    }
  }

  add (val, path, debug = false) {
    let pathStrings = this.getStringList(this.paths);
    let index = pathStrings.indexOf(path.toString());

    /*
    if(debug) {
      console.log('DataTree.add', pathStrings, index)
    }
    */

    if (index !== -1) {
      this.branches[index].push(val);
    } else {
      this.paths.push(path.clone());
      this.branches.push([]);
      this.branches[this.branches.length - 1].push(val);
    }
  }

  sortPaths(){
    let pathStrings = this.getStringList(this.paths);
    let sortedPathStrings = [...pathStrings].sort();
    let sortedPaths = sortedPathStrings.map((pathString) => {
      return new GHPath(pathString);
    });
    let sortedBranches = sortedPaths.map((path) => {
      let index = pathStrings.indexOf(path.toString());
      return this.branches[index];
    });
    this.paths = sortedPaths;
    this.branches = sortedBranches;
  }

  branchCount () {
    return this.branches.length;
  }

  remove (path, itemIndex) {
    let pathStrings = this.getStringList(this.paths);
    let pathIndex = pathStrings.indexOf(path.toString());
    if (pathIndex !== -1) {
      this.branches[pathIndex].splice(itemIndex, 1);
      if (this.branches.length === 0) {
        this.branches.splice(pathIndex, 1);
        this.paths.splice(pathIndex, 1);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/geometry/DataTree.js